import { render, staticRenderFns } from "./Tabber.vue?vue&type=template&id=e8db354e&scoped=true&"
import script from "./Tabber.vue?vue&type=script&lang=js&"
export * from "./Tabber.vue?vue&type=script&lang=js&"
import style0 from "./Tabber.vue?vue&type=style&index=0&id=e8db354e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db354e",
  null
  
)

export default component.exports